module.exports = __webpack_public_path__ + "static/media/Expansion of dental arches11.16d61fbd.png";